import React, {useState} from 'react';
import {useStateContext} from "../../../context/ContextProvider";
import BaseApi from "../../../services/Api";
// import {Link} from "react-router-dom";

import logoVipa from "../../../images/logo_vipa.png"

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const {setUser, setToken} = useStateContext();

  const submitData = () => {
    BaseApi.post('login', {
      email: email,
      password: password,
    }).then(({data}) => {
      setUser(data.user);
      setToken(data.token);
    }).catch(err => {
      const response = err.response;
      if (response && response.status === 401) {
        setError(response.data.message);
      } else {
        setError({
          email: [response.data.message]
        })
      }
    });
  }

  return (
    <div className="container login-signup-form">
      <div className="row form text">
        <form>
          <img className="m-auto d-flex" width={84} src={logoVipa} alt="Logo"/>
          <h1 className="title mt-2">
            Entre na sua conta:
          </h1>

          <input className="mb-2" onChange={(e) => setEmail(e.target.value)} type="email" placeholder="E-mail"/>
          <input className="mb-2" onChange={(e) => setPassword(e.target.value)} type="password" placeholder="Senha"/>
          {error &&
            <div className="alert alert-danger py-2" role="alert" >
              {Object.keys(error).map((key, index) => {
                return <p key={index}>{error[key][0]}</p>
              })}
            </div>
          }
          <button onClick={submitData} className="btn btn-success btn-block" type="button" >
            Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;